import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '../../components/logos/property-button-logo.png'


const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = {
  key: 1,
  class: "test-mode"
}

import { computed } from 'vue';
import headerBackButton from '../icons/header-back-button.vue';
import { useRouter } from 'vue-router';
import { RouteNames } from '@/router/RouteNames';
import { useRoute } from 'vue-router';
import { useApplicationStore } from '@/stores/ApplicationStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-header',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const applicationStore = useApplicationStore();

const displayBackButton = computed(() => {
   return (route.path === `/${RouteNames.Home}` || route.path === `/${RouteNames.OrderStatus}`) ? false : true
});

const backButtonClick = () => {
   router.back();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (displayBackButton.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "backbutton-container",
          onClick: backButtonClick
        }, [
          _createVNode(headerBackButton, {
            id: "back-button",
            width: "16px",
            height: "18px"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "BACK", -1))
        ]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      id: "property-button-logo",
      src: _imports_0
    }, null, -1)),
    (_unref(applicationStore).isTestMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Test Mode"))
      : _createCommentVNode("", true)
  ]))
}
}

})